//客户发票中维护开票组织、币种。
const invoices = {
  state: {
    invoicesSummaryParams: {},
    invoicesSummaryTotalMoney: 0,
    modalData: {},
    showModal: false,
  },
  getters: {
    GET_INVOICESUMMARYPARAMS: (state, getters, rootState) => state.invoicesSummaryParams,
    GET_INVOICESUMMARYTOTALMOENEY: (state, getters, rootState) => state.invoicesSummaryTotalMoney,
    GET_INVOICEMODALDATA: (state, getters, rootState) => state.modalData,
    GET_INVOICEMODALSHOW: (state, getters, rootState) => state.showModal,
  },
  mutations: {
    SET_INVOICESUMMARYPARAMS: (state, data) => {
      state.invoicesSummaryParams = data;
    },
    SET_INVOICESUMMARYTOTALMOENEY: (state, data) => {
      state.invoicesSummaryTotalMoney = data;
    },
    SET_INVOICEMODALDATA: (state, data) => {
      state.modalData = data;
    },
    SET_INVOICEMODALSHOW: (state, data) => {
      state.showModal = data;
    }
  },
  actions: {
  }
};

export default invoices;
